import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Typography,
  useTheme,
} from '@mui/material';
import { useIntl } from 'react-intl';

import { AllocationSummaryResponse } from '../../types/response';

interface Props {
  allocationSummary: AllocationSummaryResponse[];
}

interface Batch {
  name: string;
  key: keyof AllocationSummaryResponse;
}
export const AllocationSummaryTable = ({ allocationSummary }: Props) => {
  const batches: Batch[] = [
    {
      name: 'Validation',
      key: 'validationCount',
    },
    {
      name: 'Training',
      key: 'trainingCount',
    },
    {
      name: 'Test',
      key: 'testCount',
    },
  ] as const;
  const theme = useTheme();
  const { formatMessage } = useIntl();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(3) }}>
      <Typography variant="h6">
        {formatMessage({ id: 'createProjectWizard.step.reviewAndCreate.allocationSummary.title' })}
      </Typography>
      <Paper variant="outlined">
        <Table>
          <TableHead>
            <TableRow
              sx={{
                '&:hover': { backgroundColor: 'transparent' },
                borderBottom: `2px solid ${theme.palette.divider}`,
                backgroundColor: theme.palette.grey[100],
              }}
            >
              <TableCell>Batch</TableCell>
              <TableCell>Annotator</TableCell>
              <TableCell align="right">Encounters allocated</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {batches.map((batch) =>
              allocationSummary.map((row, index) => (
                <TableRow
                  key={`${batch.name}-${row.annotatorId}`}
                  sx={{
                    '&:hover': { backgroundColor: 'transparent' },
                    borderBottom: `1px solid ${theme.palette.divider}`,
                  }}
                >
                  {index === 0 && (
                    <TableCell
                      rowSpan={allocationSummary.length}
                      sx={{ verticalAlign: 'top', fontWeight: 500 }}
                    >
                      {batch.name}
                    </TableCell>
                  )}

                  <TableCell>{row.annotatorName}</TableCell>

                  <TableCell align="right">{row[batch.key].toLocaleString()}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
};
